module.exports = __webpack_public_path__ + "img/invalid.f1e7a0cf.svg";